import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-loader',
  template: `<div class="loader">
  <img src="assets/images/loader.gif" height="50px" width="50px"/>
</div>`,
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  constructor() { }
  ngOnInit() {
    console.log("Loader started");
  }
}



// WEBPACK FOOTER //
// ./src/app/loader/loader.component.ts